import React from 'react';
import Modal from '@common/modal';
import { JOBDA_SUPPORT_EMAIL } from '@domain/constant/contact';
import classnames from 'classnames/bind';
import styles from './modals.module.scss';
const cx = classnames.bind(styles);

interface ProfileErrorModalProps {
  visible: boolean;
  onClose: () => void;
  isUseScrollHidden?: boolean;
}

const ProfileErrorModal = ({ visible, onClose, isUseScrollHidden }: ProfileErrorModalProps) => {
  return (
    <Modal visible={visible} isUseScrollHidden={isUseScrollHidden}>
      <div className={cx('layer', 'layerError')}>
        <em className={cx('title')}>현재 서비스가 원활하지 않습니다.</em>

        <p className={cx('desc')}>
          오류가 지속될 경우
          <br />
          잡다 헬프데스크로 문의 해주세요.
        </p>

        <div className={cx('emailArea')}>
          잡다 헬프데스크 :{' '}
          <a className={cx('email')} href={`mailto:${JOBDA_SUPPORT_EMAIL}`}>
            {JOBDA_SUPPORT_EMAIL}
          </a>
        </div>

        <div className={cx('btnArea')}>
          <a className={cx('btn', 'confirm')} role="button" onClick={onClose}>
            확인
          </a>
        </div>
      </div>
    </Modal>
  );
};

export default ProfileErrorModal;
